import React from 'react';
import './LegalPage.css';
import Pricing from "../components/Pricing";

const AtencionCliente= () => (
    <div className="legal-page">
        <h1>Servicio al Cliente Inteligente</h1>
        <h2>"Tu negocio disponible 24/7: Atiende, Agenda y Vende sin pausas"</h2>
        <p>
            La atención al cliente ha evolucionado. Ya no basta con responder; necesitas una solución que actúe.
            Implementamos bots robustos con capacidad de voz y texto que unifican todos tus canales (Web, WhatsApp,
            Redes Sociales)
            para que nunca pierdas una oportunidad de venta, sin importar la hora o el idioma.
        </p>

        <h3>¿Qué puede hacer este agente por ti?</h3>
        <ul>
            <li><strong>Atención Multicanal:</strong> Centraliza Instagram, WhatsApp y Web en un solo cerebro
                inteligente.
            </li>
            <li><strong>Asistente de Voz y Llamadas:</strong> Capaz de recibir llamadas, resolver dudas complejas y
                agendar citas hablando naturalmente.
            </li>
            <li><strong>Gestión Comercial Completa:</strong> Desde el envío automático de catálogos y documentos hasta
                el cierre de ventas y cobros automatizados.
            </li>
            <li><strong>Administración de Agenda:</strong> Gestiona reservas y cancelaciones en tiempo real,
                sincronizado con tu calendario.
            </li>
        </ul>

        <h3>Tecnologías que utilizamos:</h3>
        <p>OpenAI (GPT-4), Twilio (Voz/SMS), WhatsApp Business API, Dialogflow, Integraciones REST API.</p>

        <h3>Ejemplo real:</h3>
        <p>
            Un cliente llama a tu clínica o negocio a las 2:00 AM. El asistente de voz responde, resuelve sus dudas
            sobre precios,
            le envía un folleto por WhatsApp automáticamente y agenda su cita en el hueco libre de mañana. Todo sin
            intervención humana.
        </p>

        <Pricing/>
    </div>
);
export default AtencionCliente;
